import appConfig from '../reducers/appConfig'
import {IAppStore} from '../interfaces/reducers'
import {IPaylodAction, IActionDispatcher} from '../interfaces/dispatchers'
import {ConstrImportAction} from '../enums/ActionTypes/ConstrImportAction'
import Axios from 'axios'
import {appFeatureTablesDispatcher} from './appFeatureTablesDispatcher'
import {appSingleViewDispatcher} from './appSingleViewDispatcher'
import {
  IConstrInputData,
  IConstrLayerNames,
  IConstrConnectValidationData,
  IConstrConnectValidationSuccessData,
  IConstrImportActionData
} from '../interfaces/reducers/IConstrImport'

export const updateInputData =
  (inputData: IConstrInputData) =>
  (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IAppStore) => {
    dispatch({
      type: ConstrImportAction.UPDATE_IMPORT_DATA,
      payload: inputData
    })
  }

export const updateInputDataLayers =
  (inputData: IConstrLayerNames) =>
  (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IAppStore) => {
    dispatch({
      type: ConstrImportAction.UPDATE_IMPORT_DATA_LAYERS,
      payload: inputData
    })
  }
const unError = 'Възникна грешка! Опитайте пак и или се обърнете към администратор'
export const validate =
  () => (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IAppStore) => {
    const inputData = getStore().constrImport.inputData
    const formData = new FormData()
    formData.append('File', inputData.file!.file!, inputData.file!.name)

    const payload: {[key: string]: any} = {
      LocationId: inputData.location!.getProperties()['Id'],
      PlanDate: inputData.planDate.toISOString()
    }
    const inputDataIndexed = inputData as unknown as Record<string, any>
    for (const key in inputDataIndexed) {
      if (key == 'layerNames') {
        const layerNames = inputDataIndexed[key] as Record<string, any>
        for (const k in layerNames) {
          payload[k] = layerNames[k]
        }
      } else if (typeof inputDataIndexed[key] != 'object') {
        payload[key] = inputDataIndexed[key]
      }
    }
    formData.append('RegImportInputData', JSON.stringify(payload))
    dispatch({
      type: ConstrImportAction.UPDATE_IMPORT_DATA,
      payload: {
        ...getStore().constrImport.inputData,
        loading: true,
        errors: [],
        startedImportGuid: '',
        expanded: false
      } as IConstrInputData
    })
    dispatch({
      type: ConstrImportAction.UPDATE_CONNECT_VALIDATE_DATA,
      payload: {
        ...getStore().constrImport.connectValidationData,
        loading: false,
        exists: false,
        successData: undefined
      } as IConstrConnectValidationData
    })
    dispatch({
      type: ConstrImportAction.UPDATE_IMPORT_ACTION_DATA,
      payload: {
        ...getStore().constrImport.connectValidationData,
        loading: false,
        success: false,
        errors: []
      } as IConstrImportActionData
    })
    Axios.post(`${appConfig.constrImport.constimportUrl1}`, formData, {
      headers: {'Content-Type': `multipart/form-data;`}
    })
      .then(response => {
        if (response.data['PATH']) {
          dispatch({
            type: ConstrImportAction.UPDATE_IMPORT_DATA,
            payload: {
              ...getStore().constrImport.inputData,
              startedImportGuid: response.data['PATH']
            } as IConstrInputData
          })
          dispatch(stage3(response.data['PATH']))
        } else {
          dispatch({
            type: ConstrImportAction.UPDATE_IMPORT_DATA,
            payload: {...getStore().constrImport.inputData, loading: false, errors: response.data} as IConstrInputData
          })
        }
      })
      .catch(e => {
        dispatch({
          type: ConstrImportAction.UPDATE_IMPORT_DATA,
          payload: {...getStore().constrImport.inputData, loading: false, errors: [unError]}
        })
      })
  }

//connect
const stage3 =
  (path: string) => (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IAppStore) => {
    dispatch({
      type: ConstrImportAction.UPDATE_CONNECT_VALIDATE_DATA,
      payload: {
        ...getStore().constrImport.connectValidationData,
        loading: true,
        exists: true
      } as IConstrConnectValidationData
    })
    Axios.get(appConfig.constrImport.constimportUrl2 + '/' + path)
      .then(r => {
        if (r.data && r.data.SuccessDxf) {
          const data = r.data as IConstrConnectValidationSuccessData
          data.SuccessDxf = appConfig.urls.xyApiUrl + data.SuccessDxf
          data.importPath = path
          dispatch({
            type: ConstrImportAction.UPDATE_CONNECT_VALIDATE_DATA,
            payload: {
              ...getStore().constrImport.connectValidationData,
              loading: false,
              errors: {messages: [], dxf: ''},
              successData: data
            } as IConstrConnectValidationData
          })

          dispatch({
            type: ConstrImportAction.UPDATE_IMPORT_DATA,
            payload: {...getStore().constrImport.inputData, loading: false} as IConstrInputData
          })
        } else {
          dispatch({
            type: ConstrImportAction.UPDATE_CONNECT_VALIDATE_DATA,
            payload: {
              ...getStore().constrImport.connectValidationData,
              loading: false,
              errors: {
                messages: r.data.Errors || [unError],
                dxf: r.data.ErrorsDxf
                  ? appConfig.constrImport.constImportGetFileUrl + '/' + path + '/' + r.data.ErrorsDxf
                  : ''
              }
            } as IConstrConnectValidationData
          })
          dispatch({
            type: ConstrImportAction.UPDATE_IMPORT_DATA,
            payload: {...getStore().constrImport.inputData, loading: false} as IConstrInputData
          })
        }
      })
      .catch(e => {
        dispatch({
          type: ConstrImportAction.UPDATE_CONNECT_VALIDATE_DATA,
          payload: {
            ...getStore().constrImport.connectValidationData,
            loading: false,
            errors: {messages: [unError]}
          } as IConstrConnectValidationData
        })
        dispatch({
          type: ConstrImportAction.UPDATE_IMPORT_DATA,
          payload: {...getStore().constrImport.inputData, loading: false} as IConstrInputData
        })
      })
  }

export const importReg =
  (path: string) => (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IAppStore) => {
    dispatch({
      type: ConstrImportAction.UPDATE_IMPORT_ACTION_DATA,
      payload: {...getStore().constrImport.connectValidationData, loading: true}
    })
    dispatch({
      type: ConstrImportAction.UPDATE_IMPORT_DATA,
      payload: {...getStore().constrImport.inputData, loading: true} as IConstrInputData
    })
    Axios.get(appConfig.constrImport.importReg + '/' + path)
      .then(() => {
        for (const id in getStore().layerInfos.featureLayerInfos) {
          getStore().layerInfos.featureLayerInfos[id].refresh()
        }
        const featureIds = Object.keys(getStore().data.featureTables)
        dispatch(appFeatureTablesDispatcher.setTablesVisibility({}))
        if (featureIds.length > 0) {
          dispatch(appFeatureTablesDispatcher.refrashTable(featureIds[0]))
        }
        dispatch({
          type: ConstrImportAction.UPDATE_IMPORT_ACTION_DATA,
          payload: {
            ...getStore().constrImport.connectValidationData,
            loading: false,
            success: true,
            errors: []
          } as IConstrImportActionData
        })
        dispatch({
          type: ConstrImportAction.UPDATE_IMPORT_DATA,
          payload: {...getStore().constrImport.inputData, loading: false} as IConstrInputData
        })
        dispatch(appSingleViewDispatcher.removeSelection())
      })
      .catch(e => {
        dispatch({
          type: ConstrImportAction.UPDATE_IMPORT_ACTION_DATA,
          payload: {
            ...getStore().constrImport.connectValidationData,
            loading: false,
            errors: [unError],
            success: false
          } as IConstrImportActionData
        })
        dispatch({
          type: ConstrImportAction.UPDATE_IMPORT_DATA,
          payload: {...getStore().constrImport.inputData, loading: false} as IConstrInputData
        })
      })
  }
